/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Route, Routes } from 'react-router';
import { DocsLayout } from './DocsPage/DocsLayout';
import { useDocLoader } from './DocsPage/useDocLoader';
import { DocsLoadingSkeleton } from './DocsPage/DocsLayout/DocsLoadingSkeleton';
import { DocsNotFound } from './DocsPage/DocsNotFound';

interface Props {
  appVersion?: string;
}

export const DocsPage: React.FC<Props> = ({ appVersion }) => {
  const { MDXComponents, loading } = useDocLoader();
  const indexRoute = MDXComponents.find((el) => el.slug === 'index');

  return (
    <>
      {loading ? (
        <DocsLoadingSkeleton />
      ) : (
        <DocsLayout appVersion={appVersion}>
          <Routes>
            {indexRoute && <Route path="/" element={indexRoute.module} />}
            {MDXComponents.map((el, index) => {
              const Element = el.module;
              return <Route key={index} path={el.slug} element={Element} />;
            })}
            <Route path="*" element={<DocsNotFound />} />
          </Routes>
        </DocsLayout>
      )}
    </>
  );
};
